module.exports = __webpack_public_path__ + "img/floor.072da175.webp";